module.exports = __webpack_public_path__ + "static/img/10bg_4.52de0ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/10bg_4.png
// module id = 620
// module chunks = 1